const PLEDGE_IMG =
  "https://static.prod-images.emergentagent.com/jobs/b0925e6a-374a-4fa0-bd07-856a7fe9fb4a/images/3f1c25b189579d0889ac9232e0a711a23e7e2157a8127f8c86ae42e9e5ea29f7.png";

const items = [
  {
    title: "Environmentally Responsible Products",
    body: "Where appropriate, we use environmentally responsible cleaning products and modern equipment to reduce water and chemical consumption while maintaining high cleaning standards.",
  },
  {
    title: "Modern Equipment & Reduced Consumption",
    body: "Microfiber technology and modern machinery help reduce water and chemical use across daily operations.",
  },
  {
    title: "Healthy Workspaces",
    body: "Green cleaning improves indoor air quality and eliminates harsh chemical odours in your offices.",
  },
];

export default function GreenPledge() {
  return (
    <section
      data-testid="green-pledge-section"
      id="green-pledge"
      className="bg-[#F4F8FC] py-28 md:py-40 border-t border-[#E5EBF2]"
    >
      <div className="container-ags grid md:grid-cols-12 gap-10 md:gap-16 items-center">
        <div className="md:col-span-5">
          <div className="aspect-square w-full overflow-hidden bg-white border border-[#E5EBF2] group">
            <img
              src={PLEDGE_IMG}
              alt="Eco-friendly cleaning pledge — fern on marble"
              data-testid="green-pledge-image"
              className="w-full h-full object-cover img-mono"
              loading="lazy"
            />
          </div>
        </div>

        <div className="md:col-span-7">
          <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#0E2A57]/60 font-medium">
            08 — Our Green Pledge
          </span>
          <h2 className="mt-6 font-heading font-extrabold text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-[-0.035em] text-[#050B14]">
            Eco-friendly &
            <span className="italic-display font-normal text-[#0E2A57]"> sustainable </span>
            commercial cleaning.
          </h2>
          <p className="mt-6 text-[#475569] text-lg leading-relaxed max-w-xl">
            As a family business, we care deeply about the future generation —
            so we commit to cleaning that protects your staff, your premises,
            and the environment.
          </p>

          <div className="mt-10 space-y-px bg-[#E5EBF2] border border-[#E5EBF2]">
            {items.map((it, i) => (
              <div
                key={it.title}
                data-testid={`green-item-${i}`}
                className="bg-white p-6 md:p-8 flex flex-col md:flex-row md:items-baseline gap-2 md:gap-8"
              >
                <div className="font-heading font-bold text-lg md:text-xl text-[#050B14] md:w-1/3">
                  {it.title}
                </div>
                <div className="text-[#475569] text-base leading-relaxed md:flex-1">
                  {it.body}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
